import React, { Component } from 'react';
import { Button, Card } from 'react-bootstrap'
import axios from 'axios'
import { clamp } from 'three/src/math/MathUtils.js';
import ViewModel from './viewModel';
import FilamentSelection from './filamentSelection';
import Slicing from './slicing';
import Shipping from './shipping';
import StripeContainer from './stripeContainer';
import CreateAccount from './createAccount';
import { connect } from 'react-redux';
import Login from './login';
import GCodeViewer from '../components/GCodeViewer';
import { withRouter } from "react-router-dom";
import { refreshJobInDraft, setJobInDraft } from '../actions/jobDraft';
class Print extends Component {
    state = {
        step: 0,
        maxStep: 4,
        sliced: false,
    }

    setNextStep = () => {
        let stepInc = 1
        this.setState({ step: clamp(this.state.step + stepInc, 0, this.state.maxStep) })
    }

    setPreviousStep = () => {
        this.setState({ step: clamp(this.state.step - 1, 0, this.state.maxStep) })
    }
    setModelInProgress = (filename) => {
        this.setState({ fileName: filename })
    }
    componentDidMount() {
        let darkmode = this.props.user ? this.props.user.darkmode : true
        const params = new URLSearchParams(this.props.location.search);
        const jobId = params.get("job-id");
        if (!jobId) {
            this.createJob()
        } else {
            axios.post("/api/jobs/get/job/by/id", { jobId: jobId }).then(res => {
                this.props.setJobInDraft(res.data.job)
            })
        }
    }

    createJob = () => {
        axios.post("/api/jobs/create/with/user/id").then(res => {
            this.props.setJobInDraft(res.data.job)
            this.props.history.push("/print?job-id=" + res.data.job._id)
        })
    }


    print = async () => {
        let res = await axios.post('/api/printers/print', { fileName: this.state.fileName })

    }
    sliced = () => {
        this.setState({ sliced: true })
    }

    stepRequirementsMet = () => {
        let met = true
        if (this.state.step >= 0) {
            if (!this.props.jobDraft.model) {
                met = false
            }
        }
        if (this.state.step >= 1) {
            if (this.props.jobDraft.filament == null) {
                met = false
            }
        }
        if (this.state.step >= 2) {
            if (!this.state.sliced) {
                met = false
            }
        }
        if (this.state.step >= 4) {
            if (this.props.jobDraft.shipping == null || !this.state.addressValid) {
                met = false
            }
        }
        return met
    }




    render() {
        let darkmode = this.props.user ? this.props.user.darkmode : true
        const params = new URLSearchParams(this.props.location.search);
        const jobId = params.get("job-id");
        if (this.props.jobDraft.paymentStatus == "paid") {
            this.props.history.push("/orders")
        }
        return (

            <div style={{ width: "100%" }}>

                <Card className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: "center", marginLeft: "20px", marginRight: "20px" }}>
                    <Card.Header>
                        <h2>  File: {this.props.jobDraft.originalFileName}</h2>

                    </Card.Header>
                    <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ overflow: "auto" }}>
                        {this.state.step == 0 &&
                            <ViewModel setModelInProgress={this.setModelInProgress} />
                        }
                        {this.state.step == 1 && <div>
                            <FilamentSelection />
                        </div>}
                        {this.state.step == 2 && <div>
                            <Slicing sliced={this.sliced} />
                        </div>}
                        {this.state.step == 3 && <div>
                            <GCodeViewer />
                        </div>}
                        {this.state.step == 4 && (!this.props.user ?
                            <div>


                                <Login />

                                <CreateAccount />
                            </div>


                            :

                            <Shipping valid={(v) => this.setState({ addressValid: v })} />
                        )

                        }
                    </Card.Body>
                    <Card.Footer c>

                        {this.state.step < this.state.maxStep ?
                            <Button disabled={!this.stepRequirementsMet()} style={{ width: "40%", float: "right", marginRight: "20px" }} onClick={this.setNextStep}>Next</Button>
                            :
                            this.props.user ? <StripeContainer data={{ job: this.state.job }} disabled={!this.stepRequirementsMet()} /> : null

                        }
                        <Button disabled={this.state.step == 0} style={{ width: "40%", marginLeft: "20px" }} onClick={this.setPreviousStep}>Back</Button>
                    </Card.Footer>
                </Card>




            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        jobDraft: state.jobDraft
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setJobInDraft: (data) => dispatch(setJobInDraft(data)),
        refreshJobInDraft: (jobId) => dispatch(refreshJobInDraft(jobId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Print));